import { Button, Tooltip } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineCheck } from "react-icons/ai";
import { MdContentCopy } from "react-icons/md";

import { copyToClipboard } from "shell/api/utils";

interface CopyButtonProps {
  className?: string;
  label?: string;
  size?: "small" | "middle";
  value: string;
  variant?: "icon" | "button";
}

export const CopyButton = ({
  value,
  label,
  size = "small",
  variant = "icon",
  className,
}: CopyButtonProps) => {
  const { t } = useTranslation(["sandbox", "common"]);
  const [copied, setCopied] = useState(false);
  const fallbackLabel = t("components.codeSamples.copySnippet");
  const tooltipLabel = label ?? fallbackLabel;
  const isButton = variant === "button";

  const handle = () => {
    copyToClipboard(value, () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const button = (
    <Button
      className={className}
      size={size}
      type={isButton ? "default" : "text"}
      icon={copied ? <AiOutlineCheck /> : <MdContentCopy />}
      onClick={handle}
      aria-label={tooltipLabel}
    >
      {isButton && t("common:labels.copy")}
    </Button>
  );

  return isButton ? button : <Tooltip title={tooltipLabel}>{button}</Tooltip>;
};
